import styled from "styled-components";
import designSystemColors from "../../../styles";

export const ModalHeaderTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${designSystemColors.textDark || "#1f2937"};
  margin: 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0 0 0;
`;

export const Subtitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${designSystemColors.gray700 || "#374151"};
  margin-bottom: 20px;
  text-align: center;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

interface OptionCardProps {
  active?: boolean;
  disabled?: boolean;
}

export const OptionCard = styled.button<OptionCardProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  border-radius: 8px;
  border: 2px solid
    ${(props) =>
      props.disabled
        ? "#e5e7eb"
        : props.active
        ? "#1d4ed8"
        : "#e5e7eb"};
  background-color: ${(props) =>
    props.disabled
      ? "#f9fafb"
      : props.active
      ? "#eff6ff"
      : "#ffffff"};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.55 : 1)};
  transition: all 0.2s ease-in-out;
  text-align: center;

  &:hover:not(:disabled) {
    border-color: #1d4ed8;
    background-color: #f0f7ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(29, 78, 216, 0.08);
  }
`;

export const DisabledTag = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 10px;
  font-weight: 600;
  color: #6b7280;
  background-color: #e5e7eb;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
`;

export const IconWrapper = styled.div<OptionCardProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.disabled ? "#f3f4f6" : props.active ? "#dbeafe" : "#f3f4f6"};
  color: ${(props) =>
    props.disabled
      ? "#9ca3af"
      : props.active
      ? "#1d4ed8"
      : "#4b5563"};
  margin-bottom: 12px;
  transition: all 0.2s ease-in-out;
`;

export const CardTitle = styled.span<OptionCardProps>`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) =>
    props.disabled
      ? "#9ca3af"
      : props.active
      ? "#1d4ed8"
      : "#1f2937"};
  margin-bottom: 6px;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  width: 100%;
`;